export const planCards = [
  {
    id: 'free',
    name: 'Free',
    price: '$0',
    period: '',
    tagline: 'Try it before you commit.',
    features: [
      'Up to 10 conversions',
      'Attachments included',
      'Files deleted within 24 hours',
      'No credit card required'
    ],
    cta: 'Start Free',
    modalCta: 'Continue with Free'
  },
  {
    id: 'starter',
    name: 'Starter',
    price: '$7.99',
    period: '/mo',
    yearlyPrice: '$86',
    yearlyPeriod: '/yr',
    badge: 'Most Popular',
    tagline: 'For individual professionals.',
    features: [
      '500 conversions per month',
      'Batch uploads supported',
      'Email support'
    ],
    cta: 'Get Starter'
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '$17.99',
    period: '/mo',
    yearlyPrice: '$194',
    yearlyPeriod: '/yr',
    tagline: 'For high-volume exports.',
    features: [
      '3,000 conversions per month',
      'Faster processing',
      'Priority support'
    ],
    cta: 'Get Pro'
  },
  {
    id: 'team',
    name: 'Team',
    price: '$49',
    period: '/mo',
    yearlyPrice: '$529',
    yearlyPeriod: '/yr',
    tagline: 'For shared workflows.',
    features: [
      '15,000 conversions per month',
      'Shared workspace',
      'Basic audit log'
    ],
    cta: 'Get Team'
  }
];

// What a checkout plan id is worth, in dollars, for conversion reporting.
//
// Read off the same display strings the cards above show, so a price change
// cannot leave the ads account booking the old number. Takes the checkout form
// of the id — "pro", "pro_yearly" — and returns 0 for anything it does not
// recognise; callers treat 0 as "report no value", which is better than
// reporting a wrong one.
export function planAmountUsd(priceId) {
  if (!priceId) return 0;
  const isYearly = priceId.endsWith('_yearly');
  const card = planCards.find(p => p.id === priceId.replace('_yearly', ''));
  if (!card) return 0;
  const amount = parseFloat(String((isYearly ? card.yearlyPrice : card.price) || '').replace(/[^0-9.]/g, ''));
  return Number.isFinite(amount) ? amount : 0;
}
